import { useMediaQuery } from 'react-responsive'

export const BP = { sm: 640, md: 768, lg: 1024, xl: 1280 }

export const useIsMobileSm = () => useMediaQuery({ maxWidth: BP.sm - 1 })
export const useIsMobileMd = () => useMediaQuery({ maxWidth: BP.md - 1 })
export const useIsMobileLg = () => useMediaQuery({ maxWidth: BP.lg - 1 })
export const useIsMobileXl = () => useMediaQuery({ maxWidth: BP.xl - 1 })

export const useIsDesktopSm = () => useMediaQuery({ minWidth: BP.sm })
export const useIsDesktopMd = () => useMediaQuery({ minWidth: BP.md })
export const useIsDesktopLg = () => useMediaQuery({ minWidth: BP.lg })
export const useIsDesktopXl = () => useMediaQuery({ minWidth: BP.xl })

export const useIsMobile = () => useMediaQuery({ maxWidth: BP.md - 1 })
export const useIsDesktop = () => useMediaQuery({ minWidth: BP.md })
